module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/t4MrLa/tc-custom/9781526751911.jpg?1704322027506",
      "alt": "This image is the cover for the book Armies of Ancient Greece Circa 500–338 BC"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Armies of Ancient Greece Circa 500–338 BC\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Illustrated with color photos, this guide details the arms, armor, organization, and tactics of Classical Greek armies.")]), _c('br'), _c('br'), _vm._v("The Classical period includes some of the most famous wars and battles of Ancient Greece, including the defeat of the Persians at Marathon, the Spartans’ last stand at Thermopylae, the Peloponnesian War and the March of the Ten Thousand. The Greek heavy infantry spearmen, or hoplites, are one of the most recognizable types of ancient warrior and their tightly-packed phalanx formation dominated the battlefield."), _c('br'), _c('br'), _vm._v("Covering the period from the Persian Wars to the Macedonian victory at the Battle of Chaeronea, Gabriele Esposito examines the famous hoplites heavy infantry as well as other troops, such as light infantry skirmishers and cavalry. His clear, informative text is beautifully illustrated with dozens of color photographs showing how the equipment was worn and used.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gabriele Esposito\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Gabriele Esposito is an Italian researcher and a long-time student of military history, whose interests and expertise range widely over various periods. He is the author of numerous books on armies and uniforms and is a regular contributor to many specialized magazines in Italy, France, Netherlands and UK. His many previous works include Armies of Early Colonial North America 1607-1713, published by Pen & Sword in 2018.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword/Pen and Sword Military\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0